export default __webpack_public_path__ + "static/media/LogoHites.a455c00f.svg";